import { useCallback, useEffect, useState } from 'react';

import { useIsMobile } from 'src/app/pages/starterDashboardV2/shared/hooks';

type PostpreviewContainerHookReturn = ModelHookResult<
	{
		isMobile: boolean;
		isExpanded: boolean;
	},
	{
		toggleExpanded: () => void;
	}
>;

export function usePostPreviewContainer(): PostpreviewContainerHookReturn {
	const isMobile = useIsMobile();
	const [isExpanded, setIsExpanded] = useState(false);

	useEffect(() => {
		// this relies on the fact that useIsMobile indirectly also uses useEffect to update its value after the initial render
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setIsExpanded(!isMobile);
	}, [isMobile]);

	const toggleExpanded = useCallback(() => {
		setIsExpanded((prev) => !prev);
	}, []);

	return {
		data: {
			isMobile,
			isExpanded,
		},
		actions: {
			toggleExpanded,
		},
	};
}
